module.exports = __webpack_public_path__ + "img/Rateio_Indireto_Header.3398d749.svg";